export default {
  nav: {
    home: 'Home',
    about: 'About',
    menu: 'Menu',
    gallery: 'Gallery',
    location: 'Location',
    contact: 'Contact'
  },
  hero: {
    badge: 'TURKEY\'S FIRST CHARCOAL COFFEE HOUSE',
    title: 'Mola Közde Kahveci',
    subtitle: 'Blending Traditional Turkish Coffee Culture with the Art of Charcoal Brewing',
    description: 'Unique charcoal coffee experience in the heart of Kadıköy',
    exploreMenu: 'Explore Our Menu',
    visitUs: 'Visit Us',
    feature1Title: 'Charcoal Brewing',
    feature1Desc: 'Unique flavor with traditional charcoal brewing method',
    feature2Title: 'Pioneer Concept',
    feature2Desc: 'Turkey\'s first and only charcoal coffee concept',
    feature3Title: 'In Kadıköy',
    feature3Desc: 'Waiting for you on Moda Street'
  },
  about: {
    badge: 'Our Story',
    title: 'Turkey\'s First',
    titleBold: 'Charcoal Coffee House',
    subtitle: 'A unique experience blending traditional Turkish coffee culture with a modern touch since 1988',
    experience: 'Years of Experience',
    sectionTitle: 'A Unique',
    sectionTitleBold: 'Coffee Experience',
    paragraph1: 'Mola Közde Kahveci was founded in 1988 in Eminönü with a passion. Our story, which set out to offer Turkish coffee lovers an unforgettable experience, opened a new chapter by moving to Kadıköy in 2000. We bring together traditional flavors in a modern atmosphere with Turkey\'s first and only charcoal coffee concept.',
    paragraph2: 'The charcoal brewing method brings out the aroma and taste of coffee to the highest level. Each cup of coffee is carefully prepared by our masters and served specially for you. Thanks to this unique brewing technique, you will discover the true taste of coffee.',
    paragraph3: 'We offer not only coffee, but also a warm atmosphere and friendly environment. Mola Közde Kahveci is a break point where you can meet with your friends, read books and take time for yourself.',
    feature1Title: 'Special Recipes',
    feature1Desc: 'Special coffee recipes prepared with traditional methods',
    feature2Title: 'Quality Ingredients',
    feature2Desc: 'The finest coffee beans and ingredients',
    feature3Title: 'Master Baristas',
    feature3Desc: 'Experienced and passionate coffee masters',
    feature4Title: 'Friendly Atmosphere',
    feature4Desc: 'Warm and inviting atmosphere',
    charcoalTitle: 'What is Charcoal Brewing?',
    charcoalDesc1: 'Charcoal brewing is the method of slowly cooking Turkish coffee over traditional fire with the heat of charcoal. This technique brings out the aroma and taste of coffee to the highest level. Thanks to the even heat of the charcoal, the coffee foam forms perfectly and the true flavor of the coffee emerges.',
    charcoalDesc2: 'This special brewing method requires patience and mastery. Each cup of coffee is carefully prepared by our masters and served to you in its freshest form.'
  },
  menu: {
    badge: 'Our Flavors',
    title: 'Our Menu',
    subtitle: 'Our rich menu prepared with traditional flavors and special recipes',
    coffee: 'Coffee Varieties',
    tea: 'Tea Varieties',
    cold: 'Cold Drinks & Milkshakes',
    dessert: 'Cake Varieties',
    popular: 'Popular',
    close: 'Close',
    vatIncluded: 'Prices include VAT'
  },
  gallery: {
    badge: 'Gallery',
    title: 'Moments from Mola',
    subtitle: 'Visual story of our coffee passion and warm atmosphere',
    followText: 'Follow our Instagram for more photos',
    image1Title: 'Charcoal Coffee Preparation',
    image1Desc: 'Our coffee prepared with traditional method',
    image2Title: 'Special Presentation',
    image2Desc: 'Carefully crafted presentations',
    image3Title: 'Warm Atmosphere',
    image3Desc: 'Our cozy and inviting environment',
    image4Title: 'Coffee Break',
    image4Desc: 'Distant view, peaceful moments',
    image5Title: 'In Expert Hands',
    image5Desc: 'Our experienced coffee masters',
    image6Title: 'Quality Ingredients',
    image6Desc: 'The finest coffee beans'
  },
  location: {
    badge: 'Location',
    title: 'Visit Us',
    subtitle: 'We are waiting for you in the heart of Kadıköy, on Mühürdar Street',
    addressTitle: 'Address',
    address: 'Caferağa, Mühürdar Cd. No:25, 34710 Kadıköy/Istanbul',
    getDirections: 'Get Directions',
    contactTitle: 'Contact',
    callNow: 'Call Now',
    transportTitle: 'Transportation',
    transport1: 'Kadıköy Metro - 5 minutes walking distance',
    transport2: '2 minutes walking distance to bus stops',
    transport3: 'Parking available nearby',
    openInMaps: 'Open in Google Maps'
  },
  contact: {
    phone: 'Phone',
    address: 'Address'
  },
  footer: {
    description: 'A unique experience that brings together traditional Turkish coffee culture with the art of charcoal brewing.',
    quickLinks: 'Quick Links',
    about: 'About',
    menu: 'Menu',
    gallery: 'Gallery',
    location: 'Location',
    contact: 'Contact',
    contactInfo: 'Contact Information',
    workingHours: 'Working Hours',
    everyday: 'Every Day',
    open247: 'Open 24/7',
    reservation: 'Reservation',
    reservationNote: 'Please call in advance for group reservations.',
    copyright: '© 2025 Mola Közde Kahveci. All rights reserved.'
  }
};